import { render } from "./edit-course.vue?vue&type=template&id=d5f41352"
import script from "./edit-course.vue?vue&type=script&lang=js"
export * from "./edit-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__